<template>
  <section class="footer">
    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12 col-md-2 left">
        </div>
        <div class="col-xs-12 col-md-4 col-md-offset-2 center">
          <p>2019 © {{msg}}</p>
        </div>
        <div class="col-xs-12 col-md-2 col-md-offset-2 right">
          <p class="made-by">Criado por <a class="color" href="http://somosfriday.com.br"><friday-logo></friday-logo></a></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import fridayLogo from '../components/FridaySvg.vue'

export default {
  name: 'FooterSection',
  components: {fridayLogo},
  data() {
    return {
      msg: 'Allegretti Advogados'
    }
  },
}
</script>

<style scoped lang="stylus">
  .footer
    background #F5F5F5
    padding 10px 0
    color black
    .made-by
      font-size 16px
    p, a
      color black
      text-decoration none
    .left, .right
      font-weight bold
      position relative
    .left
      top 7px
    .left
      text-align left
      a
        cursor pointer
        position relative
        display inline-block
        &:after
          transition .3s all ease
          content ''
          width 0
          height 1px
          bottom -3px
          position absolute
          background white
          display block
        &:hover
          &:after
            width 100%
    .center
      text-align center
    .right
      text-align right
@media (max-width: 1023px)
  .footer
    .left, .right
      text-align center
    .center
      margin 30px 0 20px
</style>



// WEBPACK FOOTER //
// src/components/CopyrightSection.vue